import { validateToken } from 'src/services/userServicer';

let DOMAIN = process.env.REACT_APP_DOMAIN;
let DCC_URL = process.env.REACT_APP_URL_DCC;
const MAX_COOKIE_SIZE = 4000; 

/**
 * Retrieves and reconstructs the authentication token from multiple cookies.
 * Returns null if missing or invalid.
 */


async function loadConfig() {
  try {
      const response = await fetch(`${process.env.PUBLIC_URL}/config.json`);
      const config = await response.json();
      DOMAIN = config.DOMAIN || DOMAIN; 
      DCC_URL = config.API_URL_DCC || DCC_URL;
     //onsole.log("API URL Loaded:", DOMAIN);
  } catch (error) {
      console.error("Failed to load config.json. Using default .env API URL", error);
  }
}

/*
loadConfig().then(() => {
});
*/

export function getToken(): string | null {
  if (typeof window === "undefined") return null;

  /*let tokenParts: string[] = [];
  let partIndex = 1;

  // Collect all token parts (authToken1, authToken2, ...)
  while (true) {
    const tokenPart = getCookie(`d_c_c_t_p_${partIndex}`);
    if (!tokenPart) break;
    tokenParts.push(tokenPart);
    partIndex++;
  }

  if (tokenParts.length === 0) {
    redirectToLogin();
    return null;
  }

  const token = decodeURIComponent(tokenParts.join(""));
 // console.log("Token:", token);*/
  const token = localStorage.getItem('d_c_c_t')
  return token;
}

/**
 * Splits and stores the authentication token across multiple cookies.
 */
export function setAuthToken(token: string) {
  if (typeof window === "undefined") return;

  clearAuthToken(); // Ensure no old tokens remain

 /* const encodedToken = encodeURIComponent(token);
  const tokenParts = splitString(encodedToken, MAX_COOKIE_SIZE);
  
  tokenParts.forEach((part, index) => {
    document.cookie = `d_c_c_t_p_${index + 1}=${part}; domain=${DOMAIN}; path=/; secure; samesite=strict;`;
  });*/

  localStorage.setItem('d_c_c_t',token)
}

/**
 * Clears all authentication token parts from cookies.
 */
export function clearAuthToken() {
  /*let partIndex = 1;

  while (getCookie(`d_c_c_t_p_${partIndex}`)) {
    document.cookie = `d_c_c_t_p_${partIndex}=; domain=${DOMAIN}; path=/; secure; samesite=strict; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
    partIndex++;
  }*/
  localStorage.clear()
}

/**
 * Validates JWT token.
 */
export async function isValidToken(token: string): Promise<boolean> {
  try {
   

    const response = await validateToken(token);

    if (response.success) {
      return true;
    }

    return false;
  } catch (error) {
    console.error("Invalid token:", error);
    return false;
  }
}

/**
 * Redirects user to login page if not authenticated.
 */
export function redirectToLogin() {
  if (typeof window !== "undefined") {
    //window.location.href = DCC_URL + "/login";
  }
}

/**
 * Splits a long string into smaller parts.
 */
function splitString(str: string, size: number): string[] {
  const result: string[] = [];
  for (let i = 0; i < str.length; i += size) {
    result.push(str.substring(i, i + size));
  }
  return result;
}

/**
 * Helper to get a cookie value by name.
 */
function getCookie(name: string): any {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : null;
}
